export default __webpack_public_path__ + "static/media/Snd_CN.a9802665.mp3";